import { Input } from "antd";
import styled from "styled-components";

export const ReadOnlyInput = styled(Input)`
  &.ant-input[disabled] {
    color: inherit;
    background-color: inherit;
  }
`;
